/* upsb-mega-menu.js — hover delay, keyboard, and touch handling */

(function () {
  'use strict';

  const items = document.querySelectorAll('.header__menu-item-wrapper[data-mega]');
  if (!items.length) return;

  const HOVER_OPEN_DELAY = 120;
  const HOVER_CLOSE_DELAY = 180;

  items.forEach((item) => {
    const trigger = item.querySelector(':scope > .header__menu-item, :scope > a');
    const panel = item.querySelector('.mega-menu');
    if (!trigger || !panel) return;

    let openTimer, closeTimer;

    const setOpen = (isOpen) => {
      item.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    };

    const scheduleOpen = () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => setOpen(true), HOVER_OPEN_DELAY);
    };

    const scheduleClose = () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => setOpen(false), HOVER_CLOSE_DELAY);
    };

    // Hover — desktop
    item.addEventListener('mouseenter', scheduleOpen);
    item.addEventListener('mouseleave', scheduleClose);

    // Touch/click — first tap on parent opens, second tap on child follows.
    // Only prevents default on the trigger itself (not on child links inside
    // the panel).
    trigger.addEventListener('click', (e) => {
      const coarse = window.matchMedia('(hover: none)').matches;
      if (coarse && !item.classList.contains('is-open')) {
        e.preventDefault();
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        setOpen(true);
      }
    });

    // Keyboard focus — open on focus-in, close when focus leaves the group
    item.addEventListener('focusin', () => {
      clearTimeout(closeTimer);
      setOpen(true);
    });

    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  // Escape key closes any open panel and returns focus to its trigger
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.header__menu-item-wrapper[data-mega].is-open').forEach((item) => {
      const trigger = item.querySelector(':scope > .header__menu-item, :scope > a');
      const panel = item.querySelector('.mega-menu');
      item.classList.remove('is-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      if (panel) panel.setAttribute('aria-hidden', 'true');
    });
  });

  // Close open panels when clicking outside the header
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.header__menu-item-wrapper[data-mega].is-open').forEach((item) => {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        const trigger = item.querySelector(':scope > .header__menu-item, :scope > a');
        const panel = item.querySelector('.mega-menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
    });
  });
})();
